import { render, staticRenderFns } from "./specialOffer.vue?vue&type=template&id=2a1c038e"
import script from "./specialOffer.vue?vue&type=script&lang=js"
export * from "./specialOffer.vue?vue&type=script&lang=js"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports